module.exports = __webpack_public_path__ + "static/media/tecnoempleo.c460f622.svg";